import React, { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hoc/AuthProvider/useAuth";

interface ProtectedPageProps {
  permissions?: string | string[];
  modules?: string | string[];
}

const ProtectedPage: React.FC<PropsWithChildren<ProtectedPageProps>> = ({
  children,
  permissions,
  modules,
}) => {
  const { havePermission, haveModule } = useAuth();

  if (permissions && !havePermission(permissions)) {
    return <Navigate to="/Dashboard" replace />;
  }

  if (modules && modules !== "0" && !haveModule(modules)) {
    return <Navigate to="/Dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedPage;
